import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeApiClient, tokenManager } from '@flote/app-core';
import { App } from './App';
import './styles/global.css';

// Lazy-load Sentry — doesn't need to block initial render
import('@flote/sentry-browser/api').then(({ initSentryBrowser }) => {
  initSentryBrowser({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    appName: 'flote-storefront',
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    enableReplay: true,
    debug: import.meta.env.DEV,
  });
});

// Configure token manager to use localStorage for persistent 24-hour auth
tokenManager.configure({ storageType: 'local' });

// Initialize API client before rendering
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:4000';
initializeApiClient({
  baseUrl: apiUrl,
  getToken: () => tokenManager.getToken(),
  appSource: 'flote-storefront',
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
